import { useEffect, useState, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Link, useMatch } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { FaAngleDown } from "react-icons/fa";
import { SearchContext } from "./Contexts/Context";
import logo from "../images/logo.png";
import SearchInput from "./search/SearchInput";
import { getMenu } from "../service/service";

function HeaderApi() {
  const navigate = useNavigate();
  const navigateToContacts = () => {
    navigate("/contact");
  };

  const [wraper, setWraper] = useState(false);
  const handlewraper = (e) => {
    e.stopPropogation();
    setWraper((prev) => !prev);
  };
  const ref = useRef();
  const handleBurgerButton = () => {
    ref.current.checked = false;
  };

  const { language } = useContext(SearchContext);
  const [content, setContent] = useState([]);

  useEffect(() => {
    const getMainMenu = async () => {
      const res = await getMenu();
      setContent(res);
    };
    getMainMenu();
  }, []);

  const [width, setWidth] = useState(window.innerWidth);
  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
  });

  const homeMatch = useMatch("/");

  const [small, setSmall] = useState(true);

  useEffect(() => {
    const scrollHandler = () => {
      if (width < 500) {
        setSmall(window.scrollY < 40);
      }
      if (width < 700) {
        setSmall(window.scrollY < 50);
      } else {
        setSmall(window.scrollY < 100);
      }
    };

    if (typeof window !== "undefined") {
      window.addEventListener("scroll", scrollHandler, { passive: true });
    }

    return () => {
      window.removeEventListener("scroll", scrollHandler, { passive: true });
    };
  }, []);

  /* DROPDOWN language */
  const data = [
    { id: 1, link: "geo", label: "GE" },
    { id: 2, link: "eng", label: "ENG" },
  ];

  const [isOpen, setOpen] = useState(false);
  const toggleDropdown = () => setOpen(!isOpen);

  return (
    <>
      <nav
        className={[
          "padding-280px",
          homeMatch && small ? "transparent" : "colorful",
        ].join(" ")}
      >
        <div className="topNav">
          <div className="topNav-items">
            <div className="topNav-socials">
              <a href="https://www.facebook.com/KhuloCityHall" target="blank">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/khulocityhall/" target="blank">
                <FaInstagram />
              </a>
              <a
                href="https://www.youtube.com/channel/UCCP3nGfRLDohB8GWsDmM8mA"
                target="blank"
                className="youtube"
              >
                <FaYoutube />
              </a>
            </div>
          </div>
          <div className="topNav-items">
            <Link to="/">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="topNav-items">
            <div className="topNav-last">
              <SearchInput language={language} />
              <div className="search">
                <div className="dropdown">
                  <div className="dropdown-header" onClick={toggleDropdown}>
                    {/* {selectedItem
                      ? items.find((item) => item.id == selectedItem).label
                      : "GE"}
                    <FaAngleDown /> */}
                  </div>
                  {/* <div className={`dropdown-body ${isOpen && "open"}`}>
                    {items.map((item) => (
                      <>
                        {selectedItem == item.id ? (
                          ""
                        ) : (
                          <div
                            className="dropdown-item"
                            onClick={(e) => handleItemClick(e.target.id)}
                            id={item.id}
                          >
                            {item.label}
                          </div>
                        )}
                      </>
                    ))}
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="bottomNav">
          <div className="hotline">
            <span>
              {"ცხელი ხაზი"}
              <span>sfg</span> +995 551 00 52 72
            </span>
          </div>
          {content?.map((menuItem) => (
            <div key={menuItem.id} className="dropdown">
              <div className="hoverButtons">
                <button className="dropbtn">
                  {menuItem.name}
                  {content.map((menuItem) => {
                    <span key={menuItem.id}>{menuItem.name}</span>;
                  })}
                  <FaAngleDown />
                </button>
                <div className={`dropdown-content ${"flex-reverse"}`}>
                  {menuItem.children.map((childItem) => (
                    <Link to={`/${childItem.slug}`} key={childItem.id}>
                      {childItem.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <div className="bottomNav-contact" onClick={navigateToContacts}>
            <span>
              <Link to="/contact">{"კონტაქტი"}</Link>
            </span>
          </div>
        </div>

        <div
          className="wrapperr"
          style={wraper ? { height: "667px" } : { height: "50px" }}
        >
          <nav>
            <input
              type="checkbox"
              id="menu"
              name="menu"
              className="m-menu__checkbox"
              ref={ref}
            />
            <label
              className="m-menu__toggle"
              htmlFor="menu"
              onClick={() => setWraper((prev) => !prev)}
            >
              <svg
                width="35"
                height="35"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth="2"
                strokeLinecap="butt"
                strokeLinejoin="arcs"
              >
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </svg>
            </label>
            <label className="m-menu__overlay" htmlFor="menu"></label>

            <div className="m-menu">
              <div className="m-menu__header">
                <label
                  className="m-menu__toggle"
                  htmlFor="menu"
                  onClick={() => setWraper((prev) => !prev)}
                >
                  <svg
                    width="35"
                    height="35"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#000000"
                    strokeWidth="2"
                    strokeLinecap="butt"
                    strokeLinejoin="arcs"
                  >
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </label>
                <span>MENU</span>
              </div>

              <ul>
                {content.map((item, index) => (
                  <li key={item.id}>
                    <label
                      className="a-label__chevron"
                      key={item.id}
                      htmlFor={`item-${index + 1}`}
                    >
                      {/* main manu */}
                      {item.name}
                    </label>

                    <input
                      type="checkbox"
                      id={`item-${index + 1}`}
                      name={`item-${index + 1}`}
                      className="m-menu__checkbox"
                    />
                    <div className="m-menu">
                      <div className="m-menu__header">
                        <label
                          className="m-menu__toggle"
                          htmlFor={`item-${index + 1}`}
                        >
                          <svg
                            width="35"
                            height="35"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#000000"
                            strokeWidth="2"
                            strokeLinecap="butt"
                            strokeLinejoin="arcs"
                          >
                            <path d="M19 12H6M12 5l-7 7 7 7" />
                          </svg>
                        </label>

                        <span>
                          {/* header name */}
                          {item.name}
                        </span>
                      </div>
                      <ul>
                        <li>
                          <label htmlFor="">
                            {item.children.map((link) => (
                              <Link
                                key={link.id}
                                to={`/${link.slug}`}
                                onClick={[handleBurgerButton, handlewraper]}
                              >
                                {/* inner menu item */}

                                <p key={link.id}>{link.name}</p>
                              </Link>
                            ))}
                          </label>
                        </li>
                      </ul>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </nav>
        </div>
      </nav>
      <div
        className="header-wrapper"
        style={{
          display: `${window.location.pathname === "/" ? "none" : "block"}`,
        }}
      ></div>
    </>
  );
}

export default HeaderApi;
